import { render, staticRenderFns } from "./BaseFixCenter.vue?vue&type=template&id=79ab2804&scoped=true&"
import script from "./BaseFixCenter.vue?vue&type=script&lang=js&"
export * from "./BaseFixCenter.vue?vue&type=script&lang=js&"
import style0 from "./BaseFixCenter.vue?vue&type=style&index=0&id=79ab2804&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ab2804",
  null
  
)

export default component.exports